import { NextPage } from 'next';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { getEnvVariables } from 'src/data/utils/getEnvVariables';

import { logger, updateError } from 'lib/logger';
import { parseRequestMetaData } from 'lib/logger/package';

import { RouteHandlerReturn } from '../types/model';
import Page from './[[...path]]';

/**
 * Rendered for 500 errors on both server and client. Used only in Production mode.
 * @link https://nextjs.org/docs/advanced-features/custom-error-page#more-advanced-error-page-customizing
 */

const ErrorPage: NextPage = () => {
  const [pageProps, setPageProps] = useState<RouteHandlerReturn>();
  const [isLoaded, setIsLoaded] = useState(false);
  const router = useRouter();

  useEffect(() => {
    const getPageProps = async () => {
      try {
        const url = `/api/pages/error`;
        const response = await fetch(url);
        const props = (await response.json()) as RouteHandlerReturn;

        if (props?.props) {
          setPageProps(props);
        } else {
          throw new Error('Unable to fetch error page');
        }
      } catch (error) {
        setPageProps(fallbackData());
        if (error instanceof Error) {
          logger.error(updateError(error, { message: '_error.tsx' }));
        }
      } finally {
        setIsLoaded(true);
      }
    };

    getPageProps();
  }, [router.locale]);

  return isLoaded && pageProps ? <Page {...pageProps} /> : <></>;
};

ErrorPage.getInitialProps = ({ req, err }) => {
  const childLogger = logger.child(parseRequestMetaData(req));
  childLogger.error(err);
  return { error: err };
};

export default ErrorPage;

const fallbackData = (): RouteHandlerReturn => {
  return {
    props: {
      context: {
        language: 'en',
        site: 'main',
      },
      dictionary: {},
      globalSettings: {
        favicon: {
          src: '/favicon.png',
          alt: '',
        },
      },
      envVars: {
        ...getEnvVariables(),
      },
      route: {
        itemId: -1,
        type: 'page',
        template: 'flexible-template',
        path: '/error',
        slug: 'error',
        url: 'https://www.dwlaw.com/',
        fields: {},
        placeholders: {
          header: [
            // {
            //   componentName: 'CoreNavigationHeader',
            //   fields: {
            //     logo: {
            //       src: '',
            //       alt: '',
            //     },
            //     primaryNav: [],
            //   },
            // },
          ],
          content: [
            {
              componentName: 'CoreHero',
              fields: {
                header: 'An Error Occured',
              },
            },
          ],
          footer: [
            {
              componentName: 'CoreGlobalNavigationFooter',
              fields: {
                primaryNavigationGroups: [],
                secondaryNavigation: [],
                tertiaryNavigation: [],
                copyrights: [],
                socialMedia: {
                  label: '',
                  links: [],
                },
                subscribeCta: {
                  header: '',
                  description: '',
                  link: {
                    href: '',
                    label: '',
                  },
                },
              },
            },
          ],
        },
      },
    },
    notFound: false,
  };
};
